import apiClient from "@/api/client";
import type { NotificationCategory, TaskNotification } from "@/features/tasks/types";

const wrap = <T>(res: { data: { data: T } }) => res.data.data;

/**
 * Dzwonek domyślnie dostaje okno (nieprzeczytane + przypięte + 30 dni), a nie całe
 * archiwum — `olderCount` mówi, ile POZYCJI zostało poza oknem, żeby przycisk
 * „Wczytaj starsze" znał swoją liczbę.
 */
export interface NotificationListResult {
  items: TaskNotification[];
  olderCount: number;
}

/** Badge numbers. `pricing_unread` only for internal users (pricing notifications). */
export interface UnreadCount {
  count: number;
  pricing_unread?: number;
}

export const notificationsApi = {
  list: (opts?: { fullHistory?: boolean }): Promise<NotificationListResult> =>
    apiClient
      .get<{ data: TaskNotification[]; meta?: { older_count?: number } }>("/notifications/", {
        params: opts?.fullHistory ? { window: "all" } : undefined,
      })
      .then((res) => ({
        items: res.data.data,
        olderCount: res.data.meta?.older_count ?? 0,
      })),

  unreadCount: () =>
    apiClient
      .get<{ data: UnreadCount }>("/notifications/unread_count/")
      .then(wrap),

  markRead: (id: string) =>
    apiClient.patch<{ data: { id: string; is_read: boolean } }>(`/notifications/${id}/read/`, {}).then(wrap),

  // Bez kategorii czyści całą skrzynkę (jak dotąd); z kategorią — tylko otwartą zakładkę.
  markAllRead: (category?: NotificationCategory) =>
    apiClient
      .post<{ data: { marked: number } }>("/notifications/read_all/", category ? { category } : {})
      .then(wrap),

  togglePin: (id: string) =>
    apiClient.patch<{ data: { id: string; is_pinned: boolean } }>(`/notifications/${id}/pin/`, {}).then(wrap),
};
